import { UsersIcon } from "@heroicons/react/24/solid";
import { Flex, Text } from "@ui";
import { useTranslation } from "react-i18next";

interface IGuestSummaryProps {
    adultsCount: number;
    childCount: { [categoryId: string]: number };
    withIcon?: boolean;
}

export const GuestSummary = ({ adultsCount, childCount, withIcon = false }: IGuestSummaryProps) => {
    const childCountCopy = { ...childCount };
    const adultsName = adultsCount > 1 ? "adults" : "adult";
    const infantCount = childCountCopy[1] || 0; // 1 is the index of the infant category;
    delete childCountCopy[1]; // remove the infant cateogry from the child count so we keep only children
    const childrenCount = Object.values(childCountCopy).reduce((acc, curr) => acc + curr, 0);
    const childName = childrenCount > 1 ? "children" : "child";
    const infantName = infantCount > 1 ? "infants" : "infant";
    const { t } = useTranslation(["common", "name", "description"]);

    return (
        <Flex data-testid="guest-summary" className="w-full text-gray-600" justifyContent="start">
            <Text className="text-sm font-medium text-gray-800">
                {withIcon && <UsersIcon className="text-gray-600 mr-2" width={18} />} {adultsCount} {t(adultsName)}
                {childrenCount > 0 ? `, ${childrenCount} ${t(childName)}` : ""}
                {infantCount > 0 ? `, ${infantCount} ${t(infantName)}` : ""}
            </Text>
        </Flex>
    );
};
